import * as angular from "angular";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { InviteDataProvider } from "../../data-provider/invite.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { Utils } from "../../helper/utils.helper";

export class TeamController {
    public search: any;
    public active_tab: string;
    public usersCount: object;

    private readonly $scope: any;
    private readonly dialog: DialogUtils;

    public dataProvider: TeamDataProvider;
    public navigationBarService: NavigationBarHelperService;
    public userDataProvider: UserDataProvider;
    public inviteDataProvider: InviteDataProvider;

    private permissionProvider: PermissionCheck;

    constructor(
        $scope: any,
        $location: any,
        $routeParams: any,
        $timeout: any,
        DialogUtils: DialogUtils,
        PermissionCheck: PermissionCheck,
        NavigationBarHelperService: NavigationBarHelperService,
        FilterDataProvider: FilterDataProvider,
        TeamDataProvider: TeamDataProvider,
        UserDataProvider: UserDataProvider,
        InviteDataProvider: InviteDataProvider,
        Utils: Utils
    ) {
        Utils.accessCheck();
        Utils.runWootric();

        this.$scope = $scope;
        this.dialog = DialogUtils;

        this.navigationBarService = NavigationBarHelperService;
        this.dataProvider = TeamDataProvider;
        this.userDataProvider = UserDataProvider;
        this.inviteDataProvider = InviteDataProvider;

        this.permissionProvider = PermissionCheck;

        this.search = $location.search();
        if (PermissionCheck.hasPermission("CREATE_TEAM")) {
            this.active_tab = this.search.tab ? this.search.tab : "teams";
        } else {
            this.active_tab = "users";
        }

        if (!this.search.filter) {
            FilterDataProvider.clearAll();
        }

        if ($routeParams.invite) {
            $timeout(() => {
                this.openInviteDialog(null);
            });
        }
    }

    openTeamModal(ev: any): void {
        this.dialog
            .show({
                component: "vc-team-form",
                targetEvent: ev,
                scope: this.$scope,
                clickOutsideToClose: false,
                size: "large-plus",
                ariaLabel: "Create Team",
                locals: {
                    selectedTeam: {},
                    hideUsers: false,
                },
            })
            .then(() => this.dataProvider.resetItems());
    }

    openInviteDialog(ev: any): void {
        this.dialog
            .show({
                component: "vc-user-invite",
                targetEvent: ev,
                clickOutsideToClose: false,
                size: "large-plus",
            })
            .then(() => this.userDataProvider.resetUsersCount());
    }
}

angular.module("team").controller("TeamController", TeamController);
